import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from "@angular/core";
import { provideRouter } from '@angular/router';
import { routes } from "./app.routes";
import { provideStore } from "@ngrx/store";
import { provideEffects } from "@ngrx/effects";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { SolutionGuard } from "./shared/guards/solution.guard";
import { SolutionResolver } from "./shared/resolvers/solution.resolver";
import { appReducers } from "./shared/store/reducers";
import { SolutionEffects } from "./shared/store/effects/solution.effect";
import { provideThemes, Theme } from "@ux-aspects-universal/angular/theming";

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes),
        provideStore(appReducers),
        provideEffects([SolutionEffects]),
        provideHttpClient(withInterceptorsFromDi()),
        SolutionGuard, 
        SolutionResolver,
        provideThemes({
            theme: Theme.JatoDark,
            themes: {
                [Theme.JatoLight]: () => import('@ux-aspects-universal/themes/jato').then(m => m.default),
                [Theme.JatoDark]: () => import('@ux-aspects-universal/themes/jato').then(m => m.default)
            }
        })
    ]
}